import { ACTION_TYPES, useCadastrosBasicoDispatch, useCadastrosBasicoState } from "./cadastros-basico-context";
import AdminPortalAppService from "../../../../application/platform/admin-portal/admin-portal-app-service";
import { FORM_TYPES } from "./cadastros-basico-reducer";
import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import React from "react";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import { DefaultMessageProps } from "../../../components/default-message";
import { DefaultDialogProps } from "../../../components/default-dialog";

export const useCadastrosBasicoController = () => {
    const { dataSearchRequest, dataRequest, file } = useCadastrosBasicoState();
    const cadastrosBasicoDispatch = useCadastrosBasicoDispatch();
    const { showBackDrop, showMessage, showDialog } = useBaseLayoutController();

    const setInitialValues = () => {
        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setFile,
            payload: null
        });
    };

    const loadData = async (request: ITermPaggedRequest, formType: FORM_TYPES) => {
        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setIsLoadingData,
            payload: true,
        });

        switch (formType) {
            case FORM_TYPES.banners:
                const banners = await AdminPortalAppService.listBanners(request);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataPaginatedListResponse,
                    payload: banners,
                });
                break;
            case FORM_TYPES.categoriesNews:
                const categories = await AdminPortalAppService.listCategoryNews(request);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataPaginatedListResponse,
                    payload: categories,
                });
                break;
            case FORM_TYPES.linkServices:
                const links = await AdminPortalAppService.listServiceLinks(request);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataPaginatedListResponse,
                    payload: links,
                });
                break;
            case FORM_TYPES.news:
                const news = await AdminPortalAppService.listNews(request);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataPaginatedListResponse,
                    payload: news,
                });
                break;
            case FORM_TYPES.estruturaGovernametal:
                const governamentalStructure = await AdminPortalAppService.listGovernamentalSctructure(request);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataPaginatedListResponse,
                    payload: governamentalStructure,
                });
                break;
        }

        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setIsLoadingData,
            payload: false,
        });


    }
    const validFields = (formType: FORM_TYPES): boolean => {
        var isValid = true;
        switch (formType) {
            case FORM_TYPES.banners:
                if (dataRequest.title === undefined || dataRequest.title.length === 0) {
                    isValid = false;
                }

                if (dataRequest.publication === undefined || dataRequest.publication.length === 0) {
                    isValid = false;
                }
                break;
            case FORM_TYPES.news:
                if (dataRequest.title === undefined || dataRequest.title.length === 0) {
                    isValid = false;
                }
                if (dataRequest.subtitle === undefined || dataRequest.subtitle.length === 0) {
                    isValid = false;
                }
                if (dataRequest.text === undefined || dataRequest.text.length === 0) {
                    isValid = false;
                }
                if (dataRequest.categoryId === undefined || dataRequest.categoryId === 0) {
                    isValid = false;
                }
                if (dataRequest.publication === undefined || dataRequest.publication.length === 0) {
                    isValid = false;
                }
                break;
            case FORM_TYPES.categoriesNews:
                if (dataRequest.name === undefined || dataRequest.name.length === 0) {
                    isValid = false;
                }
                break;

            case FORM_TYPES.linkServices:
                if (dataRequest.title === undefined || dataRequest.title.length === 0) {
                    isValid = false;
                }
                if (dataRequest.subtitle === undefined || dataRequest.subtitle.length === 0) {
                    isValid = false;
                }
                if (dataRequest.url === undefined || dataRequest.url.length === 0) {
                    isValid = false;
                }

                break;

            case FORM_TYPES.estruturaGovernametal:
                if (dataRequest.person === undefined || dataRequest.person.length === 0) {
                    isValid = false;
                }
                if (dataRequest.type === undefined || dataRequest.type.length === 0) {
                    isValid = false;
                }


                break;
        }

        return isValid;
    }
    const save = async (formType: FORM_TYPES) => {
        if (validFields(formType)) {
            showBackDrop(true);
            switch (formType) {
                case FORM_TYPES.banners:
                    if (file != null)
                        await AdminPortalAppService.addUpdateBanner(dataRequest, file);

                    break;
                case FORM_TYPES.categoriesNews:
                    await AdminPortalAppService.addUpdateCategoryNews(dataRequest);
                    break;

                case FORM_TYPES.linkServices:
                    await AdminPortalAppService.addUpdateServiceLinks(dataRequest);
                    break;

                case FORM_TYPES.news:
                    await AdminPortalAppService.addUpdateNews(dataRequest, file);
                    break;
                case FORM_TYPES.estruturaGovernametal:
                    await AdminPortalAppService.addUpdateGovernamentalStrucuture(dataRequest, file);
                    break;
            }
            cadastrosBasicoDispatch({
                type: ACTION_TYPES.setDataResponse,
                payload: {}
            });
            cadastrosBasicoDispatch({
                type: ACTION_TYPES.setShowAddEdit,
                payload: false
            });

            showMessage({ type: 'success', message: 'Registro salvo com sucesso!' } as DefaultMessageProps)

            showBackDrop(false);

            loadData(dataSearchRequest, formType);
        } else {
            showMessage({ type: 'error', message: 'É necessário preenhcer todos os campos obrigatórios.', open: true });

        }
    }

    const deleteData = async (formType: FORM_TYPES, id: number) => {

        showBackDrop(true);


        switch (formType) {
            case FORM_TYPES.banners:
                await AdminPortalAppService.deleteBanners(id);
                break;
            case FORM_TYPES.categoriesNews:
                await AdminPortalAppService.deleteCategoryNews(id);
                break;
            case FORM_TYPES.linkServices:
                await AdminPortalAppService.deleteServiceLinks(id);
                break;
            case FORM_TYPES.news:
                await AdminPortalAppService.deleteNews(id);
                break;
            case FORM_TYPES.estruturaGovernametal:
                await AdminPortalAppService.deleteGovernamentalStructure(id);
                break;
        }
        showBackDrop(false);

        showMessage({ type: 'success', message: 'Registro excluido com sucesso!' });

        await loadData(dataSearchRequest, formType);
    }

    const loadCategoriesNews = async () => {
        const categoriesNews = await AdminPortalAppService.listCategoryNews({} as ITermPaggedRequest);

        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setCategoriesNews,
            payload: categoriesNews?.items
        });

    }
    const getData = async (formType: FORM_TYPES, id: number) => {

        showBackDrop(true);


        switch (formType) {
            case FORM_TYPES.banners:
                const banner = await AdminPortalAppService.getBanners(id);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataResponse,
                    payload: banner
                });

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: banner
                });

                break;
            case FORM_TYPES.categoriesNews:
                const category = await AdminPortalAppService.getCategoryNews(id);


                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataResponse,
                    payload: category
                });


                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: category
                });
                break;
            case FORM_TYPES.linkServices:
                const link = await AdminPortalAppService.getServiceLink(id);
                console.log(link);
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataResponse,
                    payload: link
                });

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: link
                });
                break;
            case FORM_TYPES.news:
                const news = await AdminPortalAppService.getNews(id);
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataResponse,
                    payload: news
                });

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: news
                });
                break;
            case FORM_TYPES.estruturaGovernametal:
                const governamentalStrucutre = await AdminPortalAppService.getGovernamentalStrucutre(id);

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataResponse,
                    payload: governamentalStrucutre
                });

                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: governamentalStrucutre
                });
                break;
        }

        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setShowAddEdit,
            payload: true,
        });

        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setFile,
            payload: null
        });

        showBackDrop(false);
    }

    const onChangePagination = async (formType: FORM_TYPES, page: number, pageSize: number) => {

        if (page !== undefined && page !== undefined && pageSize !== undefined) {
            // Proteção: evita re-disparo se valores não mudaram
            if (dataSearchRequest?.page === page &&
                dataSearchRequest?.pageSize === pageSize) {
                return;
            }

            // var newPage = page+1;

            console.log("Mudou a paginação", page, pageSize);

            var request = { ...dataSearchRequest, page: page, pageSize } as ITermPaggedRequest;

            cadastrosBasicoDispatch({
                type: ACTION_TYPES.setDataSearchRequest,
                payload: request,
            });


            await loadData(request, formType);
        }
    }

    const handleOnChange = (e: any) => {
        let term = dataSearchRequest.term;

        if (e.target.name === "input-term") {
            term = e.target.value;
        }


        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setDataSearchRequest,
            payload: { ...dataSearchRequest, term },
        });
    };

    const handleOnChangeForm = (formType: FORM_TYPES, e: any) => {
        switch (formType) {
            case FORM_TYPES.banners:
                let title = dataRequest.title;
                let subtitle = dataRequest.subtitle;
                let publication = dataRequest.publication;
                let published = dataRequest.published;
                let url = dataRequest.url;
                if (e.target.name === "input-title") {
                    title = e.target.value;
                } else if (e.target.name === "input-subtitle") {
                    subtitle = e.target.value;
                } else if (e.target.name === "input-url") {
                    url = e.target.value;
                } else if (e.target.name === "chk-published") {
                    published = e.target.checked;
                }
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: { ...dataRequest, title, subtitle, publication, published, url }
                });

                break;
            case FORM_TYPES.news:
                let title2 = dataRequest.title;
                let subtitle2 = dataRequest.subtitle;
                let published2 = dataRequest.published;
                let categoryId = dataRequest.categoryId;
                let text = dataRequest.text;
                if (e.target.name === "input-title") {
                    title2 = e.target.value;
                } else if (e.target.name === "input-subtitle") {
                    subtitle2 = e.target.value;
                } else if (e.target.name === "input-text") {
                    text = e.target.value;
                } else if (e.target.name === "select-category") {
                    categoryId = e.target.value;
                }
                else if (e.target.name === "chk-published") {
                    published2 = e.target.checked;
                }
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: { ...dataRequest, categoryId, title: title2, subtitle: subtitle2, published: published2, text }
                });

                break;
            case FORM_TYPES.categoriesNews:
                let name = dataRequest.name;

                if (e.target.name === "input-name") {
                    name = e.target.value;
                }
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: { ...dataRequest, name }
                });

                break;

            case FORM_TYPES.linkServices:
                let id = dataRequest.id;
                let title1 = dataRequest.title;
                let subtitle1 = dataRequest.subtitle;;
                let url1 = dataRequest.url;
                let icon = dataRequest.icon;
                if (e.target.name === "input-title") {
                    title1 = e.target.value;
                } else if (e.target.name === "input-subtitle") {
                    subtitle1 = e.target.value;
                } else if (e.target.name === "input-url") {
                    url1 = e.target.value;
                } else if (e.target.name === "select-icon") {
                    icon = e.target.value;
                }
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: { ...dataRequest, id, title: title1, subtitle: subtitle1, url: url1, icon }
                });

                break;
            case FORM_TYPES.estruturaGovernametal:
                let person = dataRequest.person;
                let type = dataRequest.type;
                let openingHours = dataRequest.openingHours;
                let address = dataRequest.address;
                let phoneContact = dataRequest.phoneContact;
                let email = dataRequest.email;
                let competence = dataRequest.competence;
                let biography = dataRequest.biography;
                if (e.target.name === "select-type") {
                    type = e.target.value;
                }
                else if (e.target.name === "input-person") {
                    person = e.target.value;
                } else if (e.target.name === "input-openingHours") {
                    openingHours = e.target.value;
                } else if (e.target.name === "input-address") {
                    address = e.target.value;
                } else if (e.target.name === "input-phoneContact") {
                    phoneContact = e.target.value;
                    console.log(phoneContact);
                } else if (e.target.name === "input-email") {
                    email = e.target.value;
                } else if (e.target.name === "input-biography") {
                    biography = e.target.value;
                } else if (e.target.name === "input-competence") {
                    competence = e.target.value;
                }
                cadastrosBasicoDispatch({
                    type: ACTION_TYPES.setDataRequest,
                    payload: { ...dataRequest, type, person, openingHours, address, phoneContact, phonesContact: phoneContact, email, biography, competence }
                });

                break;

        }

    }

    const getCollumnsGrid = (type: FORM_TYPES): GridColDef<any>[] => {
        let columns: GridColDef<any>[];

        switch (type) {
            case FORM_TYPES.banners:
                columns = [
                    // { field: 'id', headerName: 'Id', width: 90 },
                    {
                        field: 'title',
                        flex: 1,
                        headerName: 'Título',
                    },
                    {
                        field: 'subtitle',
                        flex: 1,
                        headerName: 'Subtítulo',
                    },
                    {
                        field: "action",
                        headerName: "",
                        sortable: false,
                        flex: 0,
                        align: "center",
                        headerAlign: "center",
                        renderCell: (params) => {
                            return (
                                <React.Fragment>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={async () => {
                                            await getData(type, params.row.id);
                                        }}
                                        title="Editar"
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={async () => {
                                            showDialog({
                                                open: true,
                                                message: "Deseja realmente excluir essa informação?",
                                                onYesClick: () => {
                                                    (async () => {
                                                        await deleteData(type, params.row.id);
                                                    })();
                                                }
                                            } as DefaultDialogProps);
                                        }}
                                        title="Excluir"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>)
                        }
                    }
                ];
                break;
            case FORM_TYPES.categoriesNews:
                columns = [
                    // { field: 'id', headerName: 'Id', width: 90 },
                    {
                        field: 'name',
                        flex: 1,
                        headerName: 'Nome',
                    },
                    {
                        field: "action",
                        headerName: "",
                        sortable: false,
                        flex: 0,
                        align: "center",
                        headerAlign: "center",
                        renderCell: (params) => {
                            return (
                                <React.Fragment>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={async () => {
                                            await getData(type, params.row.id);
                                        }}
                                        title="Editar"
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={async () => {
                                            showDialog({
                                                open: true,
                                                message: "Deseja realmente excluir essa informação?",
                                                onYesClick: () => {
                                                    (async () => {
                                                        await deleteData(type, params.row.id);
                                                    })();
                                                }
                                            } as DefaultDialogProps);
                                        }}
                                        title="Excluir"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>)
                        }
                    }
                ];
                break;
            case FORM_TYPES.news:
                columns = [
                    // { field: 'id', headerName: 'Id', width: 90 },
                    {
                        field: 'title',
                        flex: 1,
                        headerName: 'Titulo',
                    },
                    {
                        field: 'subtitle',
                        flex: 1,
                        headerName: 'Subtítulo',
                    },
                    {
                        field: 'category',
                        flex: 1,
                        headerName: 'Categoria',
                    },
                    {
                        field: "action",
                        headerName: "",
                        sortable: false,
                        flex: 0,
                        align: "center",
                        headerAlign: "center",
                        renderCell: (params) => {
                            return (
                                <React.Fragment>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={async () => {
                                            await getData(type, params.row.id);
                                        }}
                                        title="Editar"
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={async () => {
                                            showDialog({
                                                open: true,
                                                message: "Deseja realmente excluir essa informação?",
                                                onYesClick: () => {
                                                    (async () => {
                                                        await deleteData(type, params.row.id);
                                                    })();
                                                }
                                            } as DefaultDialogProps);
                                        }}
                                        title="Excluir"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>)
                        }
                    }
                ];

                break;
            case FORM_TYPES.linkServices:
                columns = [
                    // { field: 'id', headerName: 'Id', width: 90 },
                    {
                        field: 'title',
                        flex: 1,
                        headerName: 'Titulo',
                    },
                    {
                        field: 'subtitle',
                        flex: 1,
                        headerName: 'Subtítulo',
                    },
                    {
                        field: "action",
                        headerName: "",
                        sortable: false,
                        flex: 0,
                        align: "center",
                        headerAlign: "center",
                        renderCell: (params) => {
                            return (
                                <React.Fragment>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={async () => {
                                            await getData(type, params.row.id);
                                        }}
                                        title="Editar"
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={async () => {
                                            showDialog({
                                                open: true,
                                                message: "Deseja realmente excluir essa informação?",
                                                onYesClick: () => {
                                                    (async () => {
                                                        await deleteData(type, params.row.id);
                                                    })();
                                                }
                                            } as DefaultDialogProps);
                                        }}
                                        title="Excluir"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>)
                        }
                    }
                ];
                break;
            case FORM_TYPES.estruturaGovernametal:
                columns = [
                    // { field: 'id', headerName: 'Id', width: 90 },
                    {
                        field: 'person',
                        flex: 1,
                        headerName: 'Pessoa ou  Departamento',
                    },
                    {
                        field: "action",
                        headerName: "",
                        sortable: false,
                        flex: 0,
                        align: "center",
                        headerAlign: "center",
                        renderCell: (params) => {
                            return (
                                <React.Fragment>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={async () => {
                                            await getData(type, params.row.id);
                                        }}
                                        title="Editar"
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={async () => {
                                            showDialog({
                                                open: true,
                                                message: "Deseja realmente excluir essa informação?",
                                                onYesClick: () => {
                                                    (async () => {
                                                        await deleteData(type, params.row.id);
                                                    })();
                                                }
                                            } as DefaultDialogProps);
                                        }}
                                        title="Excluir"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>)
                        }
                    }
                ];

                break;
            default:
                columns = [];
                break;
        }

        return columns;
    }
    const clearFormFieldss = async () => {
        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setDataRequest,
            payload: [],
        });
        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setFile,
            payload: null,
        });
    }
    const clearFieldss = async (type: FORM_TYPES) => {
        var request = { page: 0, pageSize: 50, term: "" } as ITermPaggedRequest;

        cadastrosBasicoDispatch({
            type: ACTION_TYPES.setDataSearchRequest,
            payload: request,
        });

        await loadData(request, type);
    }



    return { loadCategoriesNews, setInitialValues, loadData, clearFormFieldss, save, onChangePagination, getData, clearFieldss, handleOnChange, getCollumnsGrid, handleOnChangeForm };
}